// You can customize the template with the help of this file
import logoSmall from "@src/assets/images/logo/bitexbot-logo-sm.png";
import logoWhiteSmall from "@src/assets/images/logo/bitexbot-logo-white-sm.png";
import logoOnlyTextSmall from "@src/assets/images/logo/bitexbot-logo-onlytext-sm.png";
import logoOnlyTextWhiteSmall from "@src/assets/images/logo/bitexbot-logo-onlytext-white-sm.png";

//Template config options
const themeConfig = {
  app: {
    appName: logoOnlyTextSmall,
    appNameWhite: logoOnlyTextWhiteSmall,
    appLogoImage: logoSmall,
    appLogoImageWhite: logoWhiteSmall,
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
};

export default themeConfig;
